import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-become-virsa-channel-partner-distributor',
  templateUrl: './become-virsa-channel-partner-distributor.component.html',
  styleUrls: ['./become-virsa-channel-partner-distributor.component.scss']
})
export class BecomeVirsaChannelPartnerDistributorComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('Become a VIRSA Channel Partner, Dealer & Distributor in India');
    this.metaService.updateTag({ name: 'description', content: 'Join VIRSA as a channel partner, dealer, or distributor for smart classroom and EdTech solutions. Grow your business with high-demand education technology products.' });
    this.metaService.updateTag({ name: 'keywords', content: 'Virsa channel partner, smart classroom distributor India, interactive flat panel dealer, EdTech distributor opportunity, smart classroom business opportunity, interactive panel dealership India' });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
